/* eslint-disable */
/* tslint:disable */
/*
 * DO NOT EDIT THIS FILE!
 * YOUR CHANGES WILL BE OVERWRITTEN!
 * FILE IS BASED ON .wuf/testkits/enzyme.template.ejs
 * AND GENERATED BY `wuf export-testkits`
 */
import {
  enzymeTestkitFactoryCreator,
  WrapperData,
  enzymeUniTestkitFactoryCreator,
} from '@wix/wix-ui-test-utils/enzyme';


import { accordionDriverFactory } from '../components/Accordion/Accordion.driver';
export const accordionTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(accordionDriverFactory);

import { actionsMenuLayoutDriverFactory } from '../components/ActionsMenuLayout/ActionsMenuLayout.driver';
export const actionsMenuLayoutTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(actionsMenuLayoutDriverFactory);

import { addItemDriverFactory } from '../components/AddItem/AddItem.driver';
export const addItemTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(addItemDriverFactory);

import { autocompleteDriverFactory } from '../components/Autocomplete/Autocomplete.legacy.driver';
export const autocompleteTestkitFactory: (
  obj: WrapperData,
) => any = enzymeTestkitFactoryCreator(autocompleteDriverFactory);

import { avatarDriverFactory } from '../components/Avatar/Avatar.driver';
export const avatarTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(avatarDriverFactory);

import { avatarGroupDriverFactory } from '../components/AvatarGroup/AvatarGroup.driver';
export const avatarGroupTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(avatarGroupDriverFactory);

import { badgeDriverFactory } from '../components/Badge/Badge.driver';
export const badgeTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(badgeDriverFactory);

import { boxSelectionDriverFactory } from '../components/BoxSelection/BoxSelection.driver';
export const boxSelectionTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(boxSelectionDriverFactory);

import { breadcrumbsDriverFactory } from '../components/Breadcrumbs/Breadcrumbs.driver';
export const breadcrumbsTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(breadcrumbsDriverFactory);

import { buttonDriverFactory } from '../components/Button/Button.driver';
export const buttonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(buttonDriverFactory);

import { calendarCellDriverFactory } from '../components/CalendarCell/CalendarCell.driver';
export const calendarCellTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(calendarCellDriverFactory);

import { calendarPopoverDriverFactory } from '../components/CalendarPopover/CalendarPopover.driver';
export const calendarPopoverTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(calendarPopoverDriverFactory);

import { cardDriverFactory } from '../components/Card/Card.driver';
export const cardTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(cardDriverFactory);

import { checkboxDriverFactory } from '../components/Checkbox/Checkbox.driver';
export const checkboxTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(checkboxDriverFactory);

import { checkboxGroupDriverFactory } from '../components/CheckboxGroup/CheckboxGroup.driver';
export const checkboxGroupTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(checkboxGroupDriverFactory);

import { colorPickerDriverFactory } from '../components/ColorPicker/ColorPicker.driver';
export const colorPickerTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(colorPickerDriverFactory);

import { copyUrlButtonDriverFactory } from '../components/CopyUrlButton/CopyUrlButton.driver';
export const copyUrlButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(copyUrlButtonDriverFactory);

import { counterDriverFactory } from '../components/Counter/Counter.driver';
export const counterTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(counterDriverFactory);

import { counterBadgeDriverFactory } from '../components/CounterBadge/CounterBadge.driver';
export const counterBadgeTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(counterBadgeDriverFactory);

import { customDialogDriverFactory } from '../components/CustomDialog/CustomDialog.driver';
export const customDialogTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(customDialogDriverFactory);

import { datePickerInputDriverFactory } from '../components/DatePickerInput/DatePickerInput.driver';
export const datePickerInputTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(datePickerInputDriverFactory);

import { datePickerInputOldDriverFactory } from '../components/DatePickerInputOld/DatePickerInputOld.driver';
export const datePickerInputOldTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(datePickerInputOldDriverFactory);

import { dialogDriverFactory } from '../components/Dialog/Dialog.driver';
export const dialogTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(dialogDriverFactory);

import { dotNavigationDriverFactory } from '../components/DotNavigation/DotNavigation.driver';
export const dotNavigationTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(dotNavigationDriverFactory);

import { dropdownDriverFactory } from '../components/Dropdown/Dropdown.driver';
export const dropdownTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(dropdownDriverFactory);

import { eventDriverFactory } from '../components/Event/Event.driver';
export const eventTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(eventDriverFactory);

import { fileUploadDriverFactory } from '../components/FileUpload/FileUpload.driver';
export const fileUploadTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(fileUploadDriverFactory);

import { floatingDropdownDriverFactory } from '../components/FloatingDropdown/FloatingDropdown.driver';
export const floatingDropdownTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(floatingDropdownDriverFactory);

import { gridDriverFactory } from '../components/Grid/Grid.driver';
export const gridTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(gridDriverFactory);

import { heroImageDriverFactory } from '../components/HeroImage/HeroImage.driver';
export const heroImageTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(heroImageDriverFactory);

import { iconButtonDriverFactory } from '../components/IconButton/IconButton.driver';
export const iconButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(iconButtonDriverFactory);

import { iconToggleDriverFactory } from '../components/IconToggle/IconToggle.driver';
export const iconToggleTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(iconToggleDriverFactory);

import { iconTooltipDriverFactory } from '../components/IconTooltip/IconTooltip.driver';
export const iconTooltipTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(iconTooltipDriverFactory);

import { imageDriverFactory } from '../components/Image/Image.driver';
export const imageTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(imageDriverFactory);

import { inputDriverFactory } from '../components/Input/Input.legacy.driver';
export const inputTestkitFactory: (
  obj: WrapperData,
) => any = enzymeTestkitFactoryCreator(inputDriverFactory);

import { inputDialogDriverFactory } from '../components/InputDialog/InputDialog.driver';
export const inputDialogTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(inputDialogDriverFactory);

import { legacyCardDriverFactory } from '../components/LegacyCard/LegacyCard.driver';
export const legacyCardTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(legacyCardDriverFactory);

import { likeButtonDriverFactory } from '../components/LikeButton/LikeButton.driver';
export const likeButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(likeButtonDriverFactory);

import { mediaLabelDriverFactory } from '../components/MediaLabel/MediaLabel.driver';
export const mediaLabelTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(mediaLabelDriverFactory);

import { mobileDrawerDriverFactory } from '../components/MobileDrawer/MobileDrawer.driver';
export const mobileDrawerTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(mobileDrawerDriverFactory);

import { overlappingCardDriverFactory } from '../components/OverlappingCard/OverlappingCard.driver';
export const overlappingCardTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(overlappingCardDriverFactory);

import { paginationDriverFactory } from '../components/Pagination/Pagination.driver';
export const paginationTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(paginationDriverFactory);

import { pickerDriverFactory } from '../components/Picker/Picker.driver';
export const pickerTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(pickerDriverFactory);

import { popoverDriverFactory } from '../components/Popover/Popover.driver';
export const popoverTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(popoverDriverFactory);

import { progressBarDriverFactory } from '../components/ProgressBar/ProgressBar.driver';
export const progressBarTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(progressBarDriverFactory);

import { radioButtonDriverFactory } from '../components/RadioButton/RadioButton.driver';
export const radioButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(radioButtonDriverFactory);

import { radioButtonGroupDriverFactory } from '../components/RadioButtonGroup/RadioButtonGroup.driver';
export const radioButtonGroupTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(radioButtonGroupDriverFactory);

import { rangeDriverFactory } from '../components/Range/Range.driver';
export const rangeTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(rangeDriverFactory);

import { ratingsDriverFactory } from '../components/Ratings/Ratings.driver';
export const ratingsTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(ratingsDriverFactory);

import { ratingsInputDriverFactory } from '../components/RatingsInput/RatingsInput.driver';
export const ratingsInputTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(ratingsInputDriverFactory);

import { reactionsDriverFactory } from '../components/Reactions/Reactions.driver';
export const reactionsTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(reactionsDriverFactory);

import { reviewSummaryDriverFactory } from '../components/ReviewSummary/ReviewSummary.driver';
export const reviewSummaryTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(reviewSummaryDriverFactory);

import { ribbonDriverFactory } from '../components/Ribbon/Ribbon.driver';
export const ribbonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(ribbonDriverFactory);

import { sectionNotificationDriverFactory } from '../components/SectionNotification/SectionNotification.driver';
export const sectionNotificationTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(sectionNotificationDriverFactory);

import { shareButtonDriverFactory } from '../components/ShareButton/ShareButton.driver';
export const shareButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(shareButtonDriverFactory);

import { skeletonLineDriverFactory } from '../components/SkeletonLine/SkeletonLine.driver';
export const skeletonLineTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(skeletonLineDriverFactory);

import { socialBarDriverFactory } from '../components/SocialBar/SocialBar.driver';
export const socialBarTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(socialBarDriverFactory);

import { spinnerDriverFactory } from '../components/Spinner/Spinner.driver';
export const spinnerTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(spinnerDriverFactory);

import { statesButtonDriverFactory } from '../components/StatesButton/StatesButton.driver';
export const statesButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(statesButtonDriverFactory);

import { stripCardDriverFactory } from '../components/StripCard/StripCard.driver';
export const stripCardTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(stripCardDriverFactory);

import { tabbedContentDriverFactory } from '../components/TabbedContent/TabbedContent.driver';
export const tabbedContentTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(tabbedContentDriverFactory);

import { tabsDriverFactory } from '../components/Tabs/Tabs.driver';
export const tabsTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(tabsDriverFactory);

import { tagDriverFactory } from '../components/Tag/Tag.driver';
export const tagTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(tagDriverFactory);

import { tagsDriverFactory } from '../components/Tags/Tags.driver';
export const tagsTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(tagsDriverFactory);

import { textDriverFactory } from '../components/Text/Text.legacy.driver';
export const textTestkitFactory: (
  obj: WrapperData,
) => any = enzymeTestkitFactoryCreator(textDriverFactory);

import { textAreaDriverFactory } from '../components/TextArea/TextArea.driver';
export const textAreaTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(textAreaDriverFactory);

import { textButtonDriverFactory } from '../components/TextButton/TextButton.driver';
export const textButtonTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(textButtonDriverFactory);

import { textFieldDriverFactory } from '../components/TextField/TextField.legacy.driver';
export const textFieldTestkitFactory: (
  obj: WrapperData,
) => any = enzymeTestkitFactoryCreator(textFieldDriverFactory);

import { threeDotsLoaderDriverFactory } from '../components/ThreeDotsLoader/ThreeDotsLoader.driver';
export const threeDotsLoaderTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(threeDotsLoaderDriverFactory);

import { thumbnailImageDriverFactory } from '../components/ThumbnailImage/ThumbnailImage.driver';
export const thumbnailImageTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(thumbnailImageDriverFactory);

import { toastDriverFactory } from '../components/Toast/Toast.driver';
export const toastTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(toastDriverFactory);

import { toggleSwitchDriverFactory } from '../components/ToggleSwitch/ToggleSwitch.driver';
export const toggleSwitchTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(toggleSwitchDriverFactory);

import { tooltipDriverFactory } from '../components/Tooltip/Tooltip.legacy.driver';
export const tooltipTestkitFactory: (
  obj: WrapperData,
) => any = enzymeTestkitFactoryCreator(tooltipDriverFactory);

import { weeklyDateNavigationDriverFactory } from '../components/WeeklyDateNavigation/WeeklyDateNavigation.driver';
export const weeklyDateNavigationTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(weeklyDateNavigationDriverFactory);

import { weeklyDatePickerDriverFactory } from '../components/WeeklyDatePicker/WeeklyDatePicker.driver';
export const weeklyDatePickerTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(weeklyDatePickerDriverFactory);

import { wowImageDriverFactory } from '../components/WowImage/WowImage.driver';
export const wowImageTestkitFactory: (
  obj: WrapperData,
) => any = enzymeUniTestkitFactoryCreator(wowImageDriverFactory);

